<template>
  <v-container class="fill-height">
    <v-row class="fill-height">
      <v-col
        cols="12"
        :md="timerViews.length == 1 ? 12 : 6"
        v-for="(view, index) in timerViews"
        :key="index"
      >
        <v-card class="fill-height" outlined>
          <v-card-title class="pb-0" style="flex-wrap: nowrap">
            <v-menu
              v-if="view.mode === 'manual'"
              ref="menu"
              v-model="view.timer.titleMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <span
                  class="font-weight-bold text-truncate"
                  :class="
                    $vuetify.breakpoint.xs ? 'text-h5' : 'display-1'
                  "
                  style="min-width: 0"
                  v-text="
                    view.timer.title != null
                      ? view.timer.title
                      : 'Click to change title'
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                </span>
              </template>
              <v-card>
                <v-text-field
                  class="mx-3"
                  v-model="view.timer.title"
                  autofocus
                >
                  <template v-slot:append-outer>
                    <v-btn
                      dense
                      color="primary"
                      v-text="'OK'"
                      @click="view.timer.titleMenu = false"
                    ></v-btn>
                  </template>
                </v-text-field>
              </v-card>
            </v-menu>
            <span
              v-else
              class="text-caption grey--text text--darken-1 text-truncate"
              v-text="'Tournament schedule'"
            ></span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              small
              color="primary"
              aria-label="Follow tournament schedule"
              @click="openPicker(index)"
            >
              <v-icon
                small
                v-text="'mdi-calendar-clock'"
              ></v-icon>
            </v-btn>
            <v-btn
              v-if="view.mode === 'schedule'"
              icon
              small
              color="primary"
              aria-label="Back to manual timer"
              @click="unbindSchedule(view.timer)"
            >
              <v-icon small v-text="'mdi-close'"></v-icon>
            </v-btn>
            <v-btn
              v-show="timerViews.length > 1"
              color="red"
              icon
              small
              aria-label="Remove timer"
              @click="deleteTimer(index)"
            >
              <v-icon v-text="'mdi-minus-circle'"></v-icon>
            </v-btn>
          </v-card-title>

          <template v-if="view.mode === 'manual'">
            <v-dialog
              v-model="view.timer.timePickerDialog"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-card-text class="py-0">
                  <v-text-field
                    v-model="view.timer.time"
                    label="Deadline"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </v-card-text>
              </template>
              <v-time-picker
                v-model="view.timer.time"
                format="24hr"
                full-width
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="view.timer.timePickerDialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="view.timer.timePickerDialog = false"
                >
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </template>

          <template v-else>
            <div
              v-if="view.empty"
              class="flex-grow-1 d-flex align-center justify-center pa-4"
            >
              <span
                class="grey--text text-center"
                v-text="'No schedule available for this tournament'"
              ></span>
            </div>
            <div v-else class="px-4 pt-3 text-center">
              <div
                class="text-overline grey--text text--darken-1"
                v-text="view.tournamentName"
              ></div>
              <div
                class="display-1 font-weight-bold"
                v-text="view.schedule.title"
              ></div>
              <div
                v-if="view.schedule.description"
                class="subtitle-1 mt-1"
                v-text="view.schedule.description"
              ></div>
              <div
                class="text-caption grey--text text--darken-1 mt-1"
                v-text="view.timeLabel"
              ></div>
              <div
                class="text-overline mt-2"
                :class="view.isTimeOut ? 'red--text' : 'primary--text'"
                v-text="view.phaseLabel"
              ></div>
            </div>
          </template>

          <flip-countdown
            v-if="view.countdownVisible"
            :deadline="view.deadline"
            :showDays="false"
            :countdownSize="countdownSlider + 'px'"
            :labelSize="countdownSlider / 5 + 'px'"
            @timeElapsed="timeElapsedHandler(view.timer)"
          ></flip-countdown>
          <div class="d-flex justify-center pa-0 ma-0">
            <v-card
              v-if="view.boardVisible"
              class="mx-10 mt-3 overflow-auto"
              :class="countdownSlider <= 70 ? 'rounded-lg' : 'rounded-xl'"
              color="#222"
              dark
              :height="countdownSlider * 1.5"
              :width="countdownSlider * 6.4"
              style="max-width: 100%"
            >
              <v-card-title class="fill-height">
                <v-spacer></v-spacer>
                <v-img
                  alt="Bridge Pocket Logo"
                  class="shrink"
                  contain
                  :src="require('../assets/logo-512px.png')"
                  transition="scale-transition"
                  :width="countdownSlider"
                />
                <div
                  class="font-weight-bold"
                  :class="now % 2 == 0 ? 'yellow--text' : 'red--text'"
                  :style="'font-size:' + countdownSlider + 'px'"
                >
                  &nbsp;Time Out
                </div>
                <v-spacer></v-spacer>
              </v-card-title>
            </v-card>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12"> </v-col>
    </v-row>
    <v-slider
      class="fill-height"
      v-model="countdownSlider"
      min="40"
      max="200"
      vertical
    ></v-slider>
    <v-btn
      color="primary"
      fab
      dark
      fixed
      bottom
      right
      aria-label="Add timer"
      @click="addTimer"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <tournament-picker
      v-model="pickerDialog"
      title="Follow tournament schedule"
      :selected-id="pickerSelectedId"
      @change="bindTournament"
    />
  </v-container>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";
import moment from "moment";
import TournamentPicker from "@/components/TournamentPicker";
import { db } from "@/App.vue";
import { ref, onValue } from "firebase/database";
import {
  parseSchedules,
  pickDisplaySchedule,
  SCHEDULE_DEADLINE_FORMAT,
} from "@/utils/schedule";

const fmt = SCHEDULE_DEADLINE_FORMAT;

function createTimer() {
  return {
    mode: "manual",
    tournamentId: null,
    tournamentName: null,
    title: null,
    titleMenu: false,
    time: null,
    timePickerDialog: false,
    deadline: moment().format(fmt),
    countdownShow: true,
    timeoutShow: false,
  };
}

export default {
  name: "FlipCountdownVue",

  components: { FlipCountdown, TournamentPicker },

  data: () => ({
    countdownSlider: 130,
    timerList: [createTimer()],
    scheduleMap: {},
    pickerDialog: false,
    pickerIndex: null,
    pickerSelectedId: null,
    interval: null,
    now: Math.trunc(new Date().getTime() / 1000),
    nowMs: Date.now(),
    unsubscribers: [],
  }),

  created() {
    this.interval = setInterval(() => {
      const ms = new Date().getTime();
      this.now = Math.trunc(ms / 500);
      this.nowMs = ms;
    }, 500);

    this.unsubscribers.push(
      onValue(ref(db, "tournamentSchedule"), (snapshot) => {
        const scheduleMap = {};
        snapshot.forEach((childSnapshot) => {
          scheduleMap[childSnapshot.key] = parseSchedules(childSnapshot);
        });
        this.scheduleMap = scheduleMap;
      })
    );
  },

  beforeDestroy() {
    clearInterval(this.interval);
    this.unsubscribers.forEach((unsubscribe) => unsubscribe());
    this.unsubscribers = [];
  },

  watch: {
    timerList: {
      handler: function (value) {
        value.forEach((timer) => {
          if (timer.mode !== "manual" || !timer.time) return;
          const hour = parseInt(timer.time.split(":")[0]);
          const minute = parseInt(timer.time.split(":")[1]);
          const deadlineMoment = moment()
            .hours(hour)
            .minutes(minute)
            .seconds(0)
            .milliseconds(0);
          timer.deadline = deadlineMoment.format(fmt);
          const upcoming = moment().isBefore(deadlineMoment);
          timer.countdownShow = upcoming;
          timer.timeoutShow = !upcoming;
        });
      },
      deep: true,
    },
  },

  computed: {
    timerViews() {
      return this.timerList.map((timer, index) => {
        const view = {
          timer,
          index,
          mode: timer.mode,
          countdownVisible: timer.mode === "manual" ? timer.countdownShow : false,
          boardVisible: timer.mode === "manual" ? timer.timeoutShow : false,
          deadline: timer.deadline,
        };
        if (timer.mode !== "schedule") return view;

        view.tournamentName = timer.tournamentName || timer.tournamentId;
        const schedules = this.scheduleMap[timer.tournamentId] || [];
        const display = pickDisplaySchedule(schedules, this.nowMs);
        if (!display) return { ...view, empty: true };

        view.schedule = display.schedule;
        view.isTimeOut = display.isTimeOut;
        view.phaseLabel = display.isTimeOut
          ? "Time Out"
          : display.isUpcoming
          ? "Starts in"
          : "Time remaining";
        view.timeLabel =
          display.schedule.dateShort +
          " • " +
          display.schedule.start +
          " - " +
          display.schedule.end;
        view.deadline = (
          display.isUpcoming
            ? display.schedule.startMoment
            : display.schedule.endMoment
        ).format(fmt);
        view.countdownVisible = !display.isTimeOut;
        view.boardVisible = display.isTimeOut;
        return view;
      });
    },
  },

  methods: {
    addTimer: function () {
      if (this.timerList.length == 4) return;
      this.timerList.push(createTimer());
      this.refreshCountdownSlider();
    },
    deleteTimer: function (index) {
      if (this.timerList.length == 1) return;
      this.timerList.splice(index, 1);
      this.refreshCountdownSlider();
    },
    refreshCountdownSlider: function () {
      switch (this.timerList.length) {
        case 1:
          this.countdownSlider = 130;
          break;
        default:
          this.countdownSlider = 70;
      }
    },
    timeElapsedHandler: function (timer) {
      timer.timeoutShow = true;
      timer.countdownShow = false;
    },
    openPicker: function (index) {
      this.pickerIndex = index;
      this.pickerSelectedId = this.timerList[index].tournamentId;
      this.pickerDialog = true;
    },
    bindTournament: function (tournament) {
      const timer = this.timerList[this.pickerIndex];
      if (!timer || !tournament) return;
      timer.mode = "schedule";
      timer.tournamentId = tournament.id;
      timer.tournamentName = tournament.name;
    },
    unbindSchedule: function (timer) {
      timer.mode = "manual";
      timer.tournamentId = null;
      timer.tournamentName = null;
      if (!timer.time) {
        timer.deadline = moment().format(fmt);
        timer.countdownShow = true;
        timer.timeoutShow = false;
        return;
      }
      const hour = parseInt(timer.time.split(":")[0]);
      const minute = parseInt(timer.time.split(":")[1]);
      const deadlineMoment = moment()
        .hours(hour)
        .minutes(minute)
        .seconds(0)
        .milliseconds(0);
      timer.deadline = deadlineMoment.format(fmt);
      const upcoming = moment().isBefore(deadlineMoment);
      timer.countdownShow = upcoming;
      timer.timeoutShow = !upcoming;
    },
  },
};
</script>
